import React from 'react';
import { Switch, BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// Contexts
import { ContentProcessContextProvider } from './context/ContentProcessContext.jsx';
import { CustomSelectContextProvider } from './context/CustomSelectContext.jsx';
import { DNDContextProvider } from './context/DNDContext.jsx';
import { FormTaskContextProvider } from './context/FormTaskContext.jsx';
import { HeaderContextProvider } from './context/HeaderContext.jsx';
import { SessionContextProvider } from './context/SessionContext.jsx';

// Router
import Routes from './routes/routes.jsx';

const App = () => {
  return (
    <>
      <SessionContextProvider>
        <HeaderContextProvider>
          <DNDContextProvider>
            <ContentProcessContextProvider>
              <FormTaskContextProvider>
                <CustomSelectContextProvider>
                  <BrowserRouter>
                    <Switch>
                      <Routes />
                    </Switch>
                  </BrowserRouter>
                </CustomSelectContextProvider>
              </FormTaskContextProvider>
            </ContentProcessContextProvider>
          </DNDContextProvider>
        </HeaderContextProvider>
      </SessionContextProvider>
      <ToastContainer theme="colored" autoClose={5000} pauseOnFocusLoss pauseOnHover position="bottom-left" />
    </>
  );
};

export default App;
